module.exports = __webpack_public_path__ + "img/essential.555718ff.svg";